import { relations } from 'drizzle-orm';
import { jsonb, pgTable, uniqueIndex, uuid } from 'drizzle-orm/pg-core';
import { patientTherapySequence } from './patient-therapy.js';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
/**
 * The cleanroom actor snapshot for a prescription, written after every step so the
 * preparation can be left and resumed at the same step. One row per sequence; it is
 * removed when production completes or the prescription is aborted.
 */
export const cleanroomStates = pgTable('cleanroom_states', {
    id: uuidv7('id').primaryKey(),
    therapySequenceId: uuid('therapy_sequence_id')
        .notNull()
        .references(() => patientTherapySequence.id, { onDelete: 'cascade', onUpdate: 'cascade' }),
    /** The persisted XState snapshot; see app/src/modules/cleanroom/state-persistence.ts. */
    state: jsonb('state').$type().notNull(),
    ...timestamps(),
    ...userActions(),
}, t => [uniqueIndex('idx_cleanroom_states_sequence').on(t.therapySequenceId)]);
export const cleanroomStatesRelations = relations(cleanroomStates, ({ one }) => ({
    therapySequence: one(patientTherapySequence, {
        fields: [cleanroomStates.therapySequenceId],
        references: [patientTherapySequence.id],
    }),
}));
//# sourceMappingURL=cleanroom-state.js.map